import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Radio, RadioGroup, FormControlLabel, Typography } from "@material-ui/core";
import { BriefingFormModel } from "pages/BriefingForm/interfaces";
import { Controller } from "react-hook-form";

export const AdType: React.FC<FieldsHookForm<BriefingFormModel>> = ({ control }) => {
    const { t } = useTranslation();
    return (
        <Box>
            <Box mb={1}>
                <Typography variant="subtitle2">{t("briefingForm.label.addTypeLabel")}</Typography>
            </Box>
            <Box display="flex" justifyContent="center" mb={1}>
                <Controller
                    name="adDesign.type"
                    control={control}
                    as={
                        <RadioGroup row>
                            <FormControlLabel
                                value="STATIC"
                                control={<Radio color="primary" />}
                                label={t("briefingForm.label.static")}
                            />
                            <FormControlLabel
                                value="ANIMATED"
                                control={<Radio color="primary" />}
                                label={t("briefingForm.label.animated")}
                            />
                        </RadioGroup>
                    }
                />
            </Box>

            <Box mb={1}>
                <Typography variant="subtitle2">{t("briefingForm.label.artisticDirection")}</Typography>
            </Box>

            <Box display="flex" justifyContent="center" mb={1}>
                <Controller
                    name="adDesign.complexity"
                    control={control}
                    as={
                        <RadioGroup row>
                            <FormControlLabel
                                value="EASY"
                                control={<Radio color="primary" />}
                                label={t("briefingForm.label.asSupplied")}
                            />
                            <FormControlLabel
                                value="MODERATE"
                                control={<Radio color="primary" />}
                                label={t("briefingForm.label.someCreative")}
                            />
                            <FormControlLabel
                                value="DIFFICULT"
                                control={<Radio color="primary" />}
                                label={t("briefingForm.label.fullCreative")}
                            />
                        </RadioGroup>
                    }
                />
            </Box>
        </Box>
    );
};
